import { BrandLogo } from './BrandLogo'
import { CarreirasNav } from './CarreirasNav'
import type { Candidato, CarreirasView, EmpresaPublica } from '../types'

interface HeroProps {
  empresa: EmpresaPublica | null
  view: CarreirasView
  showLogo: boolean
  routeType: string
  candidato: Candidato | null
  loggedIn: boolean
  onSair: () => void
  onNavEmpregos: () => void
  onNavSobre: () => void
  onNavMinhas: () => void
}

export function Hero({
  empresa,
  view,
  showLogo,
  routeType,
  candidato,
  loggedIn,
  onSair,
  onNavEmpregos,
  onNavSobre,
  onNavMinhas,
}: HeroProps) {
  const label = empresa?.empresa || 'Grupo HI'
  const isGrupoHi = /grupo\s*hi/i.test(label) || /hi\s*holding/i.test(label)
  const parts = [
    empresa?.regiao,
    empresa?.cidade && empresa?.uf
      ? `${empresa.cidade}/${empresa.uf}`
      : empresa?.cidade || empresa?.uf,
  ].filter(Boolean)
  const sub = parts[0] || 'Grande João Pessoa, Paraíba'
  const tagline =
    empresa?.tagline || 'Transformamos tecnologia em eficiência'
  const pills =
    Array.isArray(empresa?.valores) && empresa.valores.length
      ? empresa.valores.slice(0, 4)
      : ['Ética', 'Meritocracia', 'Inclusão', 'Inovação']
  const barLabel =
    view === 'minhas'
      ? 'Minhas candidaturas'
      : view === 'sobre'
        ? 'Sobre o Grupo HI'
        : 'Vagas abertas'

  return (
    <section className="cr-hero cr-hero--compact" aria-label="Grupo HI">
      <div className="cr-wrap">
        <div className="cr-hero-panel liquid-glass cr-glass-float cr-hero-unit">
          {showLogo ? (
            <div className="cr-hero-unit-top cr-nav-cluster cr-nav-cluster--solo">
              <CarreirasNav
                view={view}
                routeType={routeType}
                candidato={candidato}
                loggedIn={loggedIn}
                onSair={onSair}
                onNavEmpregos={onNavEmpregos}
                onNavSobre={onNavSobre}
                onNavMinhas={onNavMinhas}
              />
            </div>
          ) : null}

          <div className="cr-hero-unit-copy cr-hero-info">
            <div className="cr-hero-copy-lead">
              <p className="cr-eyebrow">Carreiras</p>
              <div className="cr-hero-brand-row">
                {showLogo ? (
                  <div className="cr-hero-title-logo">
                    <BrandLogo placement="hero" />
                  </div>
                ) : null}
                <h1 className="cr-hero-title">
                  {isGrupoHi ? (
                    <>
                      Grupo <span className="hi">HI</span>
                    </>
                  ) : (
                    label
                  )}
                </h1>
              </div>
              <p className="cr-sub">{sub}</p>
            </div>
            <p className="cr-hero-tagline">{tagline}</p>
            <div className="cr-hero-pills" aria-hidden="true">
              {pills.map((v) => (
                <span key={v} className="cr-pill">
                  {v}
                </span>
              ))}
            </div>
            <p className="cr-hero-unit-bar">{barLabel}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
